<wm-de-label
  [entity]="entity"
  [for]="entity.templateCode"
  [displayOnly]="true"
  *ngIf="showLabel"
></wm-de-label>

<div class="sig-container"   [ngStyle]="!templateForPermitForm ? {'border-bottom': '1px solid black'} : {}"
>
  <div fxLayout="row">

    <img [src]="imageDataPath" style="width: 100%;" *ngIf="imageDataPath" />


    <div style="height: 100px" *ngIf="!imageDataPath"></div>
  </div>
</div>
<div *ngIf="printedName" style="margin-top: 4px;">
  <strong>Printed Name:</strong> {{ printedName }}
</div>
